import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getStorage, setStorage } from "../../utils/storage";

interface ThemeState {
  isDarkMode: boolean;
}

const initialState: ThemeState = {
  isDarkMode: getStorage("darkMode") === "true" || false,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.isDarkMode = !state.isDarkMode;
      setStorage("darkMode", state.isDarkMode.toString());
      
      // Update the document class for Tailwind dark mode
      if (state.isDarkMode) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    },
    setTheme: (state, action: PayloadAction<boolean>) => {
      state.isDarkMode = action.payload;
      setStorage("darkMode", state.isDarkMode.toString());
      
      // Update the document class for Tailwind dark mode
      if (state.isDarkMode) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    },
    initializeTheme: (state) => {
      // Initialize theme on app start
      const savedTheme = getStorage("darkMode");
      if (savedTheme !== null) {
        state.isDarkMode = savedTheme === "true";
      }
      
      // Apply theme to document
      if (state.isDarkMode) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    },
  },
});

export const { toggleTheme, setTheme, initializeTheme } = themeSlice.actions;
export default themeSlice.reducer;
